import { StatusType } from '~/eds/src/types/StatusType';
import { PromptModelTestCase } from '~/features/x-ray/types/deprecated';
import { Nullable } from '~/types/Nullable';
import { Uuid } from '~/types/Uuid';

import { updatePromptModelTestCase } from './updatePromptModelTestCase';

interface Request {
  modelId: Uuid;
  version: number;
  highlightMethod: string;
  testCaseNumber: number;
  outcome: PromptModelTestCase['outcome'];
  feedback?: Nullable<string>;
  goldValue?: PromptModelTestCase['goldValue'];
  fallbackGoldValue?: PromptModelTestCase['goldValue'];
}

type Response = {
  updatedTestCase?: PromptModelTestCase;
  responseToast?: { message: string; status: StatusType };
};

export const tagAnswerForPromptModelTestCase = async ({
  modelId,
  version,
  highlightMethod,
  testCaseNumber,
  outcome,
  feedback,
  goldValue,
  fallbackGoldValue,
}: Request): Promise<Response> => {
  try {
    const response = await updatePromptModelTestCase({
      modelId,
      version,
      highlightMethod,
      testCaseNumber,
      outcome: 'incorrect',
      feedback,
      goldValue,
    });
    return {
      updatedTestCase: response,
      responseToast: { message: 'Correct answer updated.', status: 'success' },
    };
  } catch (error: any) {
    if (error.response?.status === 422) {
      // validation failed, so try to save it as a source,
      // reverting to the original outcome and fallback gold value
      try {
        const response = await updatePromptModelTestCase({
          modelId,
          version,
          highlightMethod,
          testCaseNumber,
          outcome,
          feedback,
          goldValue: fallbackGoldValue,
        });
        return {
          updatedTestCase: response,
          responseToast: {
            message:
              'The selection does not match the field type and has been saved as a source.',
            status: 'warning',
          },
        };
      } catch {
        return {
          responseToast: {
            message:
              'The selection does not match the field type and was not saved as a source.',
            status: 'danger',
          },
        };
      }
    }
    return {};
  }
};
